import {
  BreakpointQueryName, getTypography, ThemedFunctor, TypographyName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ $disabled, $interactive, $operation }) => css`
  width: 100%;
  ${($interactive || $disabled) && `
    user-select: none;
  `}

  ${$disabled && `
    opacity: .5;
  `};

  .statusIcon {
    display: flex;
  }

  .operationIcon {
    display: none;
  }

  ${$operation && !$disabled && `
    &:hover {
      .statusIcon {
        display: none;
      }

      .operationIcon {
        display: flex;
      }
    }
  `}
`;

export const icon: ThemedFunctor = ({ theme, $active }) => css`
  background: ${theme.color.background[$active ? 'primary' : 'neutral'].default.low};
  border-radius: ${theme.remRounding.M};
  width: ${theme.remSize[300]};
  height: ${theme.remSize[300]};
  color: ${theme.color.foreground[$active ? 'primary' : 'neutral'].default.low};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const index: ThemedFunctor = ({ theme, $active }) => css`
  ${getTypography(theme, TypographyName.HEADING_4)}
  color: ${theme.color.foreground[$active ? 'primary' : 'neutral'].default.low};
`;

export const info: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[200]};
`;

export const textInfo: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.remSize[50]};
  width: 10.75rem;
`;

export const detailsWrapper: ThemedFunctor = ({ theme }) => css`
  overflow: hidden;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    overflow: visible;
  }
`;

export const details: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[150]};
  flex-wrap: wrap;

  > * {
    display: flex;

    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: ${theme.color.border.neutral.default.high};
      transform: translateX(-${theme.remSize[75]});
    }

    &:first-child::before {
      display: none;
    }
  }
`;
